import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertBox, Button, DataTable, } from '@life-line-lab/components-react';
import classNames from 'classnames';
// ANTD
import { Checkbox } from 'antd';
import { DeleteFilled, UploadOutlined } from '@ant-design/icons';

interface TableDetails {
    type:string,
    format:string
}

const Attachments = ({
    input,
    error,
    handleCheckboxChange,
    uploadFileList,
    dataTableDetails,
    onHideAlert,
    onDeleteFile,
    onShowUploadModal,
    // columns,
}) => {

    const { t } = useTranslation();

    const columns = [
        {
            title: t("label.no").toLocaleUpperCase(),
            dataIndex: ['orgType'],
            width: '30px',
            render: (_: any, record: TableDetails, index) => {
                return (
                    <React.Fragment>
                        {index + 1}
                    </React.Fragment>
                )
            }
        },
        {
            title: t('label.documents').toLocaleUpperCase(),
            dataIndex: ['format'],
            render: (_: any, record: TableDetails) => {
                return (
                    <div>
                        <div>
                            <label className={classNames(record.type === "road_tax" || record.type === "photo_of_vehicle" ? 'inp-label' : 'inp-label inp-label--required')} >
                                {t(`label.${record.type}`)}
                            </label>
                        </div>
                        <div>
                            <label className='inp-label inp-label--highlight'>
                                {t(`txt.${record.format}Format`)}
                            </label>
                        </div>
                    </div>
                )
            },
        },
        {
            title: t('label.action').toLocaleUpperCase(),
            dataIndex: 'type',
            render: (_: any, record: TableDetails) => {
                return (
                    <Button
                        label={t("label.upload")}
                        icon={<UploadOutlined />}
                        isDisabled={input._id ? true : false}
                        onClick={() => {
                            onHideAlert();
                            onShowUploadModal(record);
                        }}
                    />
                );
            }
        },
        {
            title: t('label.uploadedFile'),
            dataIndex: ['primaryPhone'],
            render: (_: any, record: TableDetails) => {
                return <span>
                    {
                        input._id ?
                            (record.type === 'nric_passport' ? input?.nric_passport?.fileName : record.type === 'driving_license' ? input?.driving_license?.fileName : record.type === 'road_tax' ? input?.road_tax?.fileName : input?.photo_of_vehicle?.fileName) : (
                                uploadFileList.find(file => {
                                    return file.source === record.type;
                                })?.name || ""
                            )
                    }
                </span>
            }
        },
        {
            title: "",
            dataIndex: "actions",
            render: (_, record) => (
                input._id ? null :
                    <DeleteFilled onClick={() => { handleDeleteFile(record.type) }} />
            )
        }
    ];

    const handleDeleteFile = (type) => {
        onDeleteFile(type);
    }

    return (
        <React.Fragment>
            {
                input._id ? null :
                    <div className="center header-title">
                        {t("title.attachments").toUpperCase()}
                    </div>
            }
            <AlertBox text={error.nric_passport || error.driving_license || error.road_tax || error.photo_of_vehicle} />
            <DataTable
                rowKey={(record: TableDetails) => { return record.type }}
                columns={columns}
                dataSource={dataTableDetails}
            />
            {
                input._id ? null :
                    <div className="mt-50">
                        <Checkbox checked={input.acceptTerms} onChange={handleCheckboxChange}>
                            {t("txt.tnc")}
                        </Checkbox>
                        <AlertBox text={error.acceptTerms && t('error.pleaseSignTnC')} />
                    </div>
            }
        </React.Fragment>
    )
}

export default Attachments